export default __webpack_public_path__ + "static/media/14.f15832ab.jpg";